<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vbWL7W/tc-custom/9781118044865.jpg?1716662496683" alt="This image is the cover for the book Keep Your Donors"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Keep Your Donors
      </h1>
      <p class="bookDescription body article font2">
        <p>Written by fundraising experts Tom Ahern and Simone Joyaux, Keep Your Donors is a new, winning guide to making disappointing donor retention rates a thing of the past. This practical and provocative book will show you how to master the strategies and tactics that make fundraising communications profitable. Filled with case studies and based in part on the CFRE and AFP job analyses, Keep Your Donors is your definitive guide to getting new donorsand keeping themfor many years to come.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tom Ahern, Simone Joyaux
      </h2>
      
      <p class="authorDescription body article">Tom Ahern is recognized as one of North America's leading  authorities on how to make nonprofit communications consistently  effective. He speaks frequently in the United States and Canada on  reader psychology, direct mail principles, good (and not very good)  graphic design as applied to fundraising and nonprofit branding. He  is president of Ahern Communications, Ink, a consultancy  specializing in capital campaign materials and other nonprofit  communications. Tom's popular e-news provides tips on donor  communications. He wrote the first book on donor newsletters,  published in 2005, as well as How to Write Fundraising Materials  That Raise More Money.  Simone P. Joyaux, ACFRE, is recognized internationally as a  "thought leader" in the philanthropic sector. An expert in fund  development, board and organizational development, and strategic  planning, Simone is the author of Strategic Fund Development:  Building Profitable Relationships That Last. This book has become  an industry standard. Simone presents all over the world and is a  faculty member in the Master's Program in Philanthropy and  Development at Saint Mary's University, Minnesota. She serves  regularly on boards, is the founder of the Women's Fund of Rhode  Island, and is the former Chair of CFRE International.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wiley
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e0d0f42